module.exports = __webpack_public_path__ + "static/media/10_Doklad_2016_20170631.6927b7ac.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/10_Doklad_2016_20170631.pdf
// module id = 158
// module chunks = 0